import { isExist, getTimestamp } from 'common/utils';
import { ItemActions, Action, Item } from 'common/types';
import { getItemEntity } from 'common/assets';
import { db } from 'firebase/config';
import { setDocWithCreatedBy } from 'firebase/utils'
import { collection, doc, addDoc, updateDoc, setDoc, getDocs, query, where, deleteDoc, CollectionReference, DocumentData, runTransaction } from 'firebase/firestore';
const itemsCollection: CollectionReference<DocumentData> = collection(db, 'items');
// import { addItem, updateItem as updateItemService, deleteItem } from 'services/api';
function updateItem(item: Item): Item {
  const updItem = { ...item };
  item.lastModifiedTime = getTimestamp();
  return updItem;
}

export const createItemActions: Action<ItemActions> = (state, updateState) => ({
  select: (itemId) => updateState({ currentItemId: itemId }),

  add: async (item) => {
    const createdItem = getItemEntity(item);
    await setDocWithCreatedBy(itemsCollection, createdItem);
    updateState({ items: [...state.items, createdItem] });
    return createdItem;
  },

  update: async (item) => {

    //updateItemService(item.id, item).then(() => {
    const restItems = [...state.items.filter((entity) => entity.id !== item.id)];

    const updatedItem = updateItem(item)

    updateState({ items: [...restItems, updatedItem] });

    // Update in Firestore
    const itemRef = doc(itemsCollection, item.id);
    await updateDoc(itemRef, updatedItem);


  },
  swapSortOrder: async (item1: Item, item2: Item, sortProperty: 'sortOrder' | 'sortOrderOffer' = 'sortOrder') => {
       console.log({
        sortProperty,
        item2: item2[sortProperty],
        item1:  item1[sortProperty]
       })
       // Crear copias de los items con los sortOrder intercambiados
       const updatedItem1 = {...item1, [sortProperty]: item2[sortProperty]};
       const updatedItem2 = {...item2, [sortProperty]: item1[sortProperty]};
       
       // Primero actualizar el estado local para mejorar la experiencia del usuario
       updateState({
         items: state.items.map(item => 
           item.id === item1.id ? updatedItem1 : 
           item.id === item2.id ? updatedItem2 : 
           item
         )
       });
       
       // Luego realizar la transacción en Firestore
       await runTransaction(db, async (transaction) => {
         const item1Ref = doc(itemsCollection, item1.id);
         const item2Ref = doc(itemsCollection, item2.id);
         const item1Data = await transaction.get(item1Ref);
         const item2Data = await transaction.get(item2Ref);
         if (!item1Data.exists() || !item2Data.exists()) {
           throw "One of the documents does not exist";
         }
         transaction.update(item1Ref, { [sortProperty]: item2Data.data()[sortProperty] });
         transaction.update(item2Ref, { [sortProperty]: item1Data.data()[sortProperty] });
       });
  },
  remove: async (itemId) => {


    const updItems = [...state.items];
    const targetEntity = state.items.findIndex((entity) => itemId === entity.id);
    if (!isExist(targetEntity)) throw new Error('The specified item does not exist');
    let updItem = updItems[targetEntity];
    updItem.isDeleted = true;

    updateState({ items: updItems });
    // Delete from Firestore
    const itemRef = doc(itemsCollection, itemId);
    await updateDoc(itemRef, { isDeleted: true });

  },
});
